import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BookCard, type BookCardData } from "../../components/BookCard";
import { fetchCatalog } from "./api";

export function CatalogPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [items, setItems] = useState<BookCardData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const q = searchParams.get("q") ?? "";

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    fetchCatalog({ q: q || undefined })
      .then((data) => {
        if (active) setItems(data.items);
      })
      .catch(() => {
        if (active) setError("Não foi possível carregar o catálogo. Tente novamente em instantes.");
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [q]);

  return (
    <div>
      <h1>Catálogo</h1>
      <nav className="catalog-nav" aria-label="Explorar catálogo">
        <Link to="/colecoes">Coleções</Link>
        <Link to="/categorias">Categorias</Link>
        <Link to="/autores">Autores</Link>
      </nav>
      <form
        role="search"
        className="search-bar"
        onSubmit={(e) => {
          e.preventDefault();
          const value = (e.currentTarget.elements.namedItem("q") as HTMLInputElement).value;
          setSearchParams(value ? { q: value } : {});
        }}
      >
        <label htmlFor="catalog-search" className="search-bar__label">
          Buscar por título, autor ou assunto
        </label>
        <div className="search-bar__row">
          <input id="catalog-search" name="q" defaultValue={q} type="search" placeholder="Ex.: machine learning, SQL, MLOps…" />
          <button className="btn" type="submit">
            Buscar
          </button>
        </div>
      </form>

      {loading ? (
        <p className="text-muted" role="status">Carregando…</p>
      ) : error ? (
        <p role="alert" className="notice-error">{error}</p>
      ) : items.length === 0 ? (
        <p className="empty-state">Nenhum livro encontrado para essa busca.</p>
      ) : (
        <div className="grid-books">
          {items.map((book) => (
            <BookCard key={book.slug} book={book} />
          ))}
        </div>
      )}
    </div>
  );
}
